import { render, staticRenderFns } from "./vehicleSite.vue?vue&type=template&id=571b1a3a&"
import script from "./vehicleSite.vue?vue&type=script&lang=js&"
export * from "./vehicleSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports